/**
 * @desc 分页
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.warehouseOrganize.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/fulfilment/warehouseOrganize/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
